import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { BookOpen, X, ShoppingCart } from "lucide-react";

const SCROLL_THRESHOLD = 500;

const WorkbookFloatingCta = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (dismissed) return;
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [dismissed]);

  const handleDismiss = () => {
    setDismissed(true);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-4 left-4 right-4 z-40 md:left-auto md:right-6 md:bottom-6 md:w-auto md:max-w-lg"
        >
          <div className="flex items-center gap-3 md:gap-4 rounded-lg bg-gradient-to-r from-primary to-[hsl(var(--hero-overlay))] text-primary-foreground shadow-2xl shadow-black/40 border border-primary-foreground/10 px-4 py-3 md:px-5 md:py-3.5">
            <div className="hidden md:flex items-center justify-center w-9 h-9 rounded-md bg-secondary-bright/20 shrink-0">
              <BookOpen size={18} className="text-secondary-bright" />
            </div>

            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm font-semibold leading-tight truncate">
                Workbook: OT-Security in der Gebäudeautomation
              </p>
              <p className="text-[10px] md:text-xs text-primary-foreground/70 leading-tight truncate mt-0.5">
                Inkl. 60 Min. Online Sparring · 499,00 € netto
              </p>
            </div>

            <Link
              to="/workbook"
              className="shrink-0 inline-flex items-center gap-1.5 bg-cta text-cta-foreground px-3 py-1.5 md:px-4 md:py-2 rounded-md text-xs font-bold uppercase tracking-wider hover:bg-cta-hover transition-colors"
            >
              <ShoppingCart size={14} />
              <span className="hidden sm:inline">Kaufen</span>
            </Link>

            <button
              onClick={handleDismiss}
              aria-label="Schließen"
              className="shrink-0 text-primary-foreground/60 hover:text-primary-foreground transition-colors p-1"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WorkbookFloatingCta;
